import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ExternalLinkModule } from "@edp-directives/external-link/external-link.module";
import { TranslateModule } from "@ngx-translate/core";
import { EdpBannerAppComponent } from "./edp-banner-app.component";

@NgModule({
    declarations: [EdpBannerAppComponent],
    imports: [CommonModule, ExternalLinkModule, TranslateModule],
    exports: [EdpBannerAppComponent],
})
export class EdpBannerAppModule {}
